import { computed } from 'vue'
import { useMenuItems, useMenuItemsStudent, useMenuItemsTeacher } from './useMenuItems'
import { useToolsPopover } from './useToolsPopover'
import { RolePermission, hasPermission } from '@/constants/role'
import { useUserStore } from '@/store'

export function useSiderMenu(collapsed: any, handleAdd: () => void) {
  const {
    expandedKeys,
    // getChatMenuItem,
    getDivider,
    getAgentItems,
    getClassroomItems,
    // getSchoolItems,
    getBaseToolItems,
    getCommunityItems,
    getStoreItems,
    getSystemSettingsItems,
    getAgentAndStoreItems,
    getOtherItems,
  } = useMenuItems(collapsed, handleAdd)

  const {
    getCollapsedToolsMenuItem,
    getExpandedToolsMenuItem,
  } = useToolsPopover()

  const userStore = useUserStore()
  const userRole = computed(() => userStore.role)

  const buildSuperAdminMenu = () => {
    const items = []

    items.push(...getSystemSettingsItems())

    items.push(getDivider('divider-1'))
    // Agent section
    items.push(...getAgentAndStoreItems())

    items.push(getDivider('divider-2'))
    // Other section
    items.push(...getOtherItems())

    return items.filter(Boolean) // Remove null items
  }

  const buildNormalUserMenu = () => {
    const items = []

    // Classroom section
    items.push(...getClassroomItems())

    // Chat menu item
    // items.push(getChatMenuItem())

    // First divider
    if (hasPermission(userRole.value, RolePermission.FOLDER_VIEW)
			|| hasPermission(userRole.value, RolePermission.KNOWLEDGE_VIEW)
			|| hasPermission(userRole.value, RolePermission.TASK_VIEW)
    )
      items.push(getDivider('divider-1'))

    // Agent section
    items.push(...getAgentItems())

    // Second divider
    items.push(getDivider('divider-2'))

    // Store section
    items.push(...getStoreItems())

    // Second divider
    items.push(getDivider('divider-3'))

    // School section
    // items.push(...getSchoolItems())

    // Third divider
    // items.push(getDivider('divider-3'))

    // Base tools section
    items.push(...getBaseToolItems())

    // More tools menu item with popover
    if (collapsed.value)
      items.push(getCollapsedToolsMenuItem())
    else
      items.push(getExpandedToolsMenuItem())

    // Fourth divider
    items.push(getDivider('divider-4'))

    // Community section
    items.push(...getCommunityItems())

    return items.filter(Boolean) // Remove null items
  }

  const listMenu = computed(() => {
    if (userRole.value?.code === 'super_admin')
      return buildSuperAdminMenu()

    return buildNormalUserMenu()
  })

  return {
    listMenu,
    expandedKeys,
  }
}

export function useSiderMenuTeacher(collapsed: any) {
  const {
    expandedKeys,
    getClassroomItemsTeacher,
  } = useMenuItemsTeacher(collapsed)

  const listMenu = computed(() => {
    const items = []
    items.push(...getClassroomItemsTeacher())
    return items
  })

  return {
    listMenu,
    expandedKeys,
  }
}

export function useSiderMenuStudent(collapsed: any) {
  const {
    expandedKeys,
    getClassroomItemsStudent,
  } = useMenuItemsStudent(collapsed)

  const listMenu = computed(() => {
    const items = []
    items.push(...getClassroomItemsStudent())
    return items
  })

  return {
    listMenu,
    expandedKeys,
  }
}
